import { render, staticRenderFns } from "./FinishTrivia2.vue?vue&type=template&id=c3ec3304"
import script from "./FinishTrivia2.vue?vue&type=script&lang=js"
export * from "./FinishTrivia2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports